/**
 * All known video call workflows. Used as a Datadog facet for filtering logs.
 * Add new workflows here as needed — the type union prevents typos.
 */
export type CallWorkflow =
  | 'room-verification'
  | 'call-join'
  | 'call-leave'
  | 'call-error'
  | 'auto-recording'
  | 'waiting-room'
  | 'end-appointment'
  | 'transcription'
  | 'dial-out'
  | 'duration-tracking'
  | 'session-beacon'
  | 'patient-join'
  | 'tray-buttons'
  | 'save-appointment';

export interface CallLogContext {
  feature: 'video-call';
  workflow: CallWorkflow;
  roomId: string;
  participantType?: 'provider' | 'patient';
  appointmentId?: string;
  [key: string]: unknown;
}

/**
 * Build a structured log context for video call events.
 *
 * Usage:
 *   datadogLogs.logger.info('Recording started', callLogContext('auto-recording', { roomId, participantCount }));
 *
 * In Datadog, filter with: @feature:video-call @workflow:auto-recording
 */
export function callLogContext(
  workflow: CallWorkflow,
  attrs: { roomId: string; [key: string]: unknown },
): CallLogContext {
  return {
    feature: 'video-call',
    workflow,
    ...attrs,
  };
}
